module.exports = __webpack_public_path__ + "static/media/motorcycle.22b83254.svg";